// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11ch2","rootNoMargin":"styles_rootNoMargin__l3Ei8"};